import React, { useState, useEffect } from 'react';
import { IoIosArrowBack } from 'react-icons/io';
import { MdOutlineCurrencyRupee } from 'react-icons/md';
import { useNavigate, useLocation } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import { fetchWithAuth } from './authService';
import { API_ENDPOINTS } from '../utils/constants';
import OfferModal from './offermodal';
import celebrationAnimation from '../Celebration.json';
import Lottie from 'lottie-react';

// Notification Component
const Notification = ({ message, type, onClose }) => {
  const bgColor =
    type === 'success'
      ? '#48bb78' // bg-green-500
      : type === 'error'
        ? '#f56565' // bg-red-500
        : '#4299e1'; // bg-blue-500

  const notificationStyle = {
    position: 'fixed',
    top: '1.25rem', // 20px, top-5
    right: '1.25rem', // 20px, right-5
    zIndex: 50,
    padding: '1rem', // 16px, p-4
    borderRadius: '0.5rem', // 6px, rounded-lg
    boxShadow:
      '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)', // shadow-lg
    color: 'white',
    backgroundColor: bgColor,
    animation: 'fadeIn 0.5s ease-in-out',
  };

  const flexContainerStyle = {
    display: 'flex',
    alignItems: 'center',
  };

  const closeButtonStyle = {
    marginLeft: '1rem', // 16px, ml-4
    fontSize: '1.25rem', // 20px, text-xl
    border: 'none',
    background: 'none',
    color: 'white',
    cursor: 'pointer',
  };

  const iconStyle = {
    marginRight: '0.75rem', // 12px, mr-3
  };

  const fadeInStyle = `
    @keyframes fadeIn {
      from { opacity: 0; transform: translateY(-20px); }
      to { opacity: 1; transform: translateY(0); }
    }
  `;

  return (
    <div style={notificationStyle}>
      <style>{fadeInStyle}</style>
      <div style={flexContainerStyle}>
        <span style={iconStyle}>{type === 'success' ? '✓' : '⚠'}</span>
        <span>{message}</span>
        <button onClick={onClose} style={closeButtonStyle}>
          &times;
        </button>
      </div>
    </div>
  );
};

const BuyCoins = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [pack, setPack] = useState(3);
  const [profile, setprofile] = useState([]);
  const [price, setPrice] = useState([]);
  const [config, setConfig] = useState([]);
  const [notification, setNotification] = useState(null);
  const [loading, setLoading] = useState(false);
  const [processingPack, setProcessingPack] = useState(null);

  const secretId = useParams().secretId;

  const queryParams = new URLSearchParams(location.search);
  const songId = queryParams.get('songRequested');
  const shoutOutType = queryParams.get('shoutOutType');
  const shoutOutName = queryParams.get('shoutOutName');
  const shoutOutDesc = queryParams.get('shoutOutDesc');
  const shoutOutFrom = queryParams.get('shoutOutFrom');
  const isMidnightShoutOut = queryParams.get('isMidnightShoutOut');
  const venueId = queryParams.get('venueId');
  const fastTrack = queryParams.get('fastTrack') === 'true';
  const [showOfferModal, setShowOfferModal] = useState(false);
  const [selectedPriceId, setSelectedPriceId] = useState(null);
  const [mainPack, setMainPack] = useState(null);
  const [offerPack, setOfferPack] = useState(null);
  const [showShoutPopup, setShowShoutPopup] = useState(false);

  // Update when pack changes
  useEffect(() => {
    if (price.length > 0 && pack > 0) {
      setSelectedPriceId(price[pack - 1]?.id);
    }
  }, [pack, price]);

  useEffect(() => {
    setLoading(false); // reset on every route change
  }, [location.pathname]);
  // Show notification and auto-close after 3 seconds
  const showNotification = (message, type) => {
    setNotification({ message, type });
    setTimeout(() => setNotification(null), 3000);
  };

  const OnPackChange = ind => {
    setPack(ind);
  };

  function goBack() {
    navigate(-1);
  }

  useEffect(() => {
    if (secretId && secretId === '756e7232-2fcb-4801-98e6-c450fb0ab828') {
      const isDeepEntry = window.history.length <= 2;
      localStorage.setItem('isDeepEntry', isDeepEntry);
      setPack(4);
      return;
    }
    if (secretId) {
      console.error('Invalid secretId');
      navigate('/main');
      return;
    }
  }, [secretId]);

  useEffect(() => {
    if (pack === 4 && price.length > 0) {
      makeOrder();
    }
  }, [pack, price.length]);

  useEffect(() => {
    try {
      const token = localStorage.getItem('tringAuthToken');
      if (!token) {
        throw new Error('Authentication required. Please log in.');
      }

      // Use venueId from query params if available, otherwise fallback to localStorage
      const targetVenueId = venueId || localStorage.getItem('vId');

      if (!targetVenueId) {
        throw new Error('Please select a venue first.');
      }

      fetchWithAuth(API_ENDPOINTS.VENUE_USERS(targetVenueId), {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({}),
      });
      console.log('API CALL FOR USER TO VENUE:', targetVenueId);
    } catch (err) {
      console.error(err.message || err);
    }
  }, [venueId]);

  useEffect(() => {
    const fetchProfile = async () => {
      const token = localStorage.getItem('tringAuthToken');
      if (!token) {
        console.error('No auth token found');
        return;
      }

      try {
        const response = await fetchWithAuth(API_ENDPOINTS.USERS, {
          method: 'GET',
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        });

        if (!response.ok) throw new Error('Failed to fetch data');

        const data = await response.json();
        setprofile(data);
      } catch (error) {
        console.error('Error fetching profile:', error);
      }
    };

    fetchProfile();
  }, []);

  useEffect(() => {
    const fetchPrice = async () => {
      const token = localStorage.getItem('tringAuthToken');
      if (!token) {
        console.error('No auth token found');
        return;
      }

      try {
        const priceresponse = await fetchWithAuth(API_ENDPOINTS.ORDER_PRICE, {
          method: 'GET',
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        });

        if (!priceresponse.ok) throw new Error('Failed to fetch price');

        const data = await priceresponse.json();
        setPrice(data);
      } catch (error) {
        console.error('Error fetching prices:', error);
      }
    };

    fetchPrice();
  }, []);

  useEffect(() => {
    const fetchConfig = async () => {
      const token = localStorage.getItem('tringAuthToken');
      if (!token) {
        console.error('No auth token found');
        return;
      }

      try {
        const configresponse = await fetchWithAuth(API_ENDPOINTS.ORDER_CONFIG, {
          method: 'GET',
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        });

        if (!configresponse.ok) throw new Error('Failed to fetch config');

        const data = await configresponse.json();
        setConfig(data);
      } catch (error) {
        console.error('Error fetching config:', error);
      }
    };

    fetchConfig();
  }, []);

  const loadRazorpay = async () => {
    const script = document.createElement('script');
    script.src = 'https://checkout.razorpay.com/v1/checkout.js';
    script.async = true;
    document.body.appendChild(script);
  };

  useEffect(() => {
    loadRazorpay();
  }, []);

  const makeOrder = async (selectedPriceId = null) => {
    setLoading(true);
    const token = localStorage.getItem('tringAuthToken');
    if (!token) {
      console.error('No auth token found');
      setLoading(false);
      return;
    }

    // Find price item by id - use the passed selectedPriceId first
    const priceIdToUse = selectedPriceId || price[pack - 1]?.id;
    const priceItem = price.find(p => p.id === priceIdToUse);

    if (!priceItem) {
      console.error('Price item not found');
      setLoading(false);
      return;
    }

    try {
      // Prepare order data with all parameters
      const orderData = {
        priceId: priceIdToUse,
      };

      // Add song request data if exists
      if (songId && venueId) {
        orderData.trackId = songId;
        orderData.venueId = venueId;
      }
      // Add shoutout data if exists
      else if (shoutOutType && shoutOutName && venueId) {
        orderData.shoutOutMessage = `${shoutOutType} ${shoutOutName}`;
        orderData.wish = `${shoutOutType}`;
        orderData.recipientName = `${shoutOutName}`;
        orderData.additionalInfo = shoutOutDesc || '';
        orderData.venueId = venueId;
        orderData.isMidnightShoutOut = isMidnightShoutOut || false;
      }

      // Add fast track if requested
      if (fastTrack) {
        orderData.fastTrack = true;
      }

      const orderresponse = await fetchWithAuth(API_ENDPOINTS.ORDER, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(orderData),
      });

      if (!orderresponse.ok) throw new Error('Failed to create order');

      const data = await orderresponse.json();
      handlePayment(data, price[pack - 1].price);
    } catch (error) {
      console.error('Error creating order:', error);
      showNotification('Failed to create order', 'error');
      setLoading(false);
    }
  };

  const phoneNumber = localStorage.getItem('number') || '';
  const handlePayment = (data, price) => {
    const options = {
      key: config.key_id,
      amount: price,
      currency: 'INR',
      name: 'Tringbox',
      description: 'Coin Transaction',
      order_id: data.order_id,
      prefill: {
        contact: phoneNumber,
      },
      handler: function (response) {
        showNotification('Payment Successful!', 'success');
        window.location.reload();
        clearLoadingState();

        localStorage.setItem('confetti', true);

        // Navigate to venue if exists, otherwise to main
        if (venueId) {
          navigate(`/venues/${venueId}`);
        } else {
          navigate('/main');
        }
      },
      notes: {
        address: 'Razorpay Corporate Office',
      },
      theme: {
        color: '#CC151E',
      },
      method: {
        upi: true,
        card: false,
        netbanking: false,
        wallet: false,
        emi: false,
        paylater: false,
      },
    };

    const rzp = new window.Razorpay(options);

    rzp.on('payment.failed', function () {
      showNotification('Payment Failed!', 'error');
      clearLoadingState();
    });

    rzp.on('modal.close', function () {
      console.log('Modal closed by user.');
      clearLoadingState();
    });

    rzp.open();

    // Optional: If Razorpay modal is blocked or doesn't show
    setTimeout(() => {
      clearLoadingState();
    }, 30000); // Fallback after 15 seconds
  };

  const clearLoadingState = () => {
    setLoading(false);
  };
  useEffect(() => {
    // Razorpay modal closes via browser back or manual exit
    const resetOnBack = () => {
      setLoading(false);
    };

    window.addEventListener('focus', resetOnBack);
    return () => {
      window.removeEventListener('focus', resetOnBack);
    };
  }, []);

  const handleUserHistory = () => {
    navigate('/history');
  };

  useEffect(() => {
    const token = localStorage.getItem('tringAuthToken');
    if (!token) {
      console.error('No auth token found');
      navigate('/');
      return;
    }
  }, [navigate]);

  const randomNumber = Math.floor(Math.random() * 10) + 1;

  const handlePackClick = async i => {
    try {
      const clickedPack = price[i];
      console.log('current-pack', clickedPack);

      const token = localStorage.getItem('tringAuthToken');

      if (clickedPack?.offerPriceId) {
        const response = await fetch(
          API_ENDPOINTS.ORDER_PRICE_BY_ID(clickedPack.offerPriceId),
          {
            method: 'GET',
            headers: {
              Authorization: `Bearer ${token}`,
              'Content-Type': 'application/json',
            },
          }
        );

        if (!response.ok) {
          throw new Error(`API error: ${response.status}`);
        }

        // const foundOfferPack = await response.json();
        // setPrice(prev => [...prev, foundOfferPack]);
        // console.log('price', price);
        // console.log('clicked-pack', clickedPack);

        // if (foundOfferPack) {
        //   setShowShoutPopup(true);
        //   setMainPack(clickedPack);
        //   setOfferPack(foundOfferPack);
        //   setShowOfferModal(true);
        //   return;
        // }
      }

      setPack(i + 1);
      setSelectedPriceId(price[i].id);
    } catch (error) {
      console.error('Error in handlePackClick:', error);
    }
  };

  return (
    <div className="px-3 d-flex flex-column" style={{ minHeight: '100dvh' }}>
      {/* Notification component */}
      {notification && (
        <Notification
          message={notification.message}
          type={notification.type}
          onClose={() => setNotification(null)}
        />
      )}

      {/* Loading overlay */}
      {/* {loading && (
        <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center">
          <div className="bg-white p-6 rounded-lg">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-red-600 mx-auto"></div>
            <p className="mt-3 text-center">Processing...</p>
          </div>
        </div>
      )} */}

      <div className="d-flex flex-row justify-content-between align-items-center w-100 mb-2 mt-3">
        <div className="d-flex flex-row justify-content-center">
          <h4 className="m-0">
            <IoIosArrowBack
              className="mt-0"
              style={{ marginRight: '10px' }}
              onClick={() => navigate(-1)}
            />
          </h4>
          <h4 className="m-0" style={{ color: '#D0151C' }}>
            Buy Coins
          </h4>
        </div>
        <button
          onClick={handleUserHistory}
          style={{
            border: 'none',
            color: 'gray',
            background: 'none',
            cursor: 'pointer',
          }}
        >
          View History
        </button>
      </div>

      <div
        className="w-100 my-2 d-flex flex-column align-items-start justify-content-center text-start"
        style={{
          backgroundImage: 'url(/images/buycoins.gif)',
          backgroundPosition: 'center',
          backgroundRepeat: 'none',
          backgroundSize: '100% 100%',
          height: '20dvh',
          minHeight: '20dvh',
          color: 'white',
          paddingLeft: '40vw',
        }}
      >
        <h4 style={{ margin: 0, marginBottom: '8px' }}>You Have</h4>
        <span
          style={{
            color: '#FED111',
            fontSize: 'clamp(0px,4.5vw,20px)',
          }}
        >
          <b>{profile.coins || 0}</b>
          <span style={{ color: '#FFF', fontSize: 'clamp(0px,4vw,18px)' }}>
            {' '}
            Tring Coins
          </span>
        </span>
      </div>

      {showShoutPopup && (
        <div
          className="shout-popup"
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 3000,
            pointerEvents: 'none',
          }}
        >
          <div
            style={{
              position: 'absolute',
              width: '100%',
              height: '100%',
            }}
          >
            <Lottie
              animationData={celebrationAnimation}
              loop={false}
              autoplay={true}
            />
          </div>
        </div>
      )}

      {/* <OfferModal
        show={showOfferModal}
        onClose={() => setShowOfferModal(false)}
        mainPack={mainPack}
        offerPack={offerPack}
        makeOrder={makeOrder}
      /> */}

      {price.length === 0 ? (
        <div>Loading...</div>
      ) : (
        <div
          className="mb-2 mt-3 d-flex flex-column align-items-center px-3 py-3 position-relative"
          style={{
            gap: '14px',
            border: '2px solid #BF1A2A',
            borderRadius: '10px',
          }}
        >
          <div
            className="p-4 position-absolute"
            style={{
              background: 'url(/images/Rectanglebc.svg)',
              backgroundPosition: 'center',
              backgroundRepeat: 'none',
              backgroundSize: '100% 100%',
              top: -35,
              zIndex: 100,
            }}
          >
            <h4 className="mb-0 p-1" style={{ color: 'white' }}>
              Buy Coins
            </h4>
          </div>

          <div
            className="w-100 d-flex flex-row justify-content-between align-items-start px-3 py-4 mt-3 position-relative"
            style={{
              border: 'solid 1px rgb(217, 217, 217) ',
              borderRadius: '5px',
            }}
            onClick={() => handlePackClick(0)}
          >
            <div
              className="px-1 position-absolute"
              style={{
                background:
                  'linear-gradient(90deg, #CC151E -18.35%, #873662 108.23%)',
                color: 'white',
                fontSize: 'clamp(0px,2.9vw,13px)',
                fontWeight: 'bold',
                top: 0,
                right: 0,
                paddingTop: '2px',
                paddingBottom: '2px',
                borderRadius: '0px 4px 0px 0px',
              }}
            >
              {(
                (price?.[0]?.price - price?.[0]?.display_price) /
                price?.[0]?.display_price
              ).toFixed(2) * 100}
              %
            </div>

            <div
              className="d-flex flex-row align-items-center"
              style={{ gap: '10px' }}
            >
              <div
                className=""
                style={{
                  borderRadius: '50%',
                  border:
                    pack === 1 ? 'solid 1px #BF1A2A' : 'solid 1px #9D9D9D ',
                  height: 'fit-content',
                  padding: '3px',
                }}
              >
                <div
                  className=""
                  style={{
                    borderRadius: '50%',
                    border: 'none',
                    height: 'fit-content',
                    padding: '6px',
                    backgroundColor: pack === 1 ? '#BF1A2A' : '#FFF',
                  }}
                ></div>
              </div>
              <img
                src="/images/2coins.png"
                style={{ width: 'clamp(0px,9vw,35px)', aspectRatio: '1/1' }}
              />
              <div className="text-start">
                <h5
                  className="m-0"
                  style={{
                    fontSize: 'clamp(0px,4vw,16px)',
                    whiteSpace: 'nowrap',
                  }}
                >
                  {price?.[0]?.coins} Coins
                </h5>
                <span
                  style={{
                    color: '#9D9D9D',
                    fontSize: 'clamp(0px,3.1vw,12px)',
                    whiteSpace: 'nowrap',
                    display: 'inline-block',
                  }}
                >
                  (Upto {price[0].songs}{' '}
                  {price[0].songs === 1 ? 'Request' : 'Requests'})
                </span>
              </div>
            </div>

            <div
              className="d-flex flex-column justify-content-between col-3"
              style={{ gap: '5px' }}
            >
              <h3 className="d-flex flex-row align-items-start col-3 text-start mb-0">
                <span
                  style={{
                    fontSize: 'clamp(0px,4.3vw,15px)',
                    whiteSpace: 'nowrap',
                  }}
                >
                  <MdOutlineCurrencyRupee className="" />
                </span>{' '}
                <span
                  style={{
                    fontSize: 'clamp(0px,7vw,25px)',
                    whiteSpace: 'nowrap',
                  }}
                >
                  {' '}
                  {price?.[0]?.price}
                </span>
              </h3>
              <span
                style={{
                  fontSize: 'clamp(0px,3.3vw,12px)',
                  whiteSpace: 'nowrap',
                }}
              >
                <MdOutlineCurrencyRupee className="mb-1" />
                <span style={{ textDecoration: 'line-through' }}>
                  {price?.[0]?.display_price}
                </span>
              </span>
            </div>
          </div>

          <div
            className="w-100 d-flex flex-row justify-content-between px-3 pb-3 position-relative"
            style={{
              border: 'solid 1px rgb(217, 217, 217) ',
              borderRadius: '5px',
              paddingTop: 'clamp(0px,10vw,24px)',
            }}
            onClick={() => handlePackClick(1)}
          >
            <div
              className="px-1 position-absolute"
              style={{
                background:
                  'linear-gradient(90deg, #CC151E -18.35%, #873662 108.23%)',
                color: 'white',
                fontSize: 'clamp(0px,2.9vw,13px)',
                fontWeight: 'bold',
                top: 0,
                right: 0,
                paddingTop: '2px',
                paddingBottom: '2px',
                borderRadius: '0px 4px 0px 0px',
              }}
            >
              {(
                (price?.[1]?.price - price?.[1]?.display_price) /
                price?.[1]?.display_price
              ).toFixed(2) * 100}
              %
            </div>
            <div className="col-8 ">
              <div
                className="d-flex flex-row align-items-center"
                style={{ gap: '10px' }}
              >
                <div
                  className=""
                  style={{
                    borderRadius: '50%',
                    border:
                      pack === 2 ? 'solid 1px #BF1A2A' : 'solid 1px #9D9D9D ',
                    height: 'fit-content',
                    padding: '3px',
                  }}
                >
                  <div
                    className=""
                    style={{
                      borderRadius: '50%',
                      border: 'none',
                      height: 'fit-content',
                      padding: '6px',
                      backgroundColor: pack === 2 ? '#BF1A2A' : '#FFF',
                    }}
                  ></div>
                </div>
                <img
                  src="/images/10coins.png"
                  style={{ width: 'clamp(0px,9vw,35px)', aspectRatio: '1/1' }}
                />
                <div className="text-start">
                  <h5
                    className="m-0 text-start"
                    style={{
                      fontSize: 'clamp(0px,4vw,16px)',
                    }}
                  >
                    {price?.[1]?.coins} Coins
                  </h5>
                  <span
                    className="text-start"
                    style={{
                      color: '#9D9D9D',
                      fontSize: 'clamp(0px,3.3vw,13px)',
                    }}
                  >
                    ( Upto {price[1].songs}{' '}
                    {price[1].songs === 1 ? 'Request' : 'Requests'} )
                  </span>
                </div>
              </div>
            </div>

            <div
              className="d-flex flex-column justify-content-between col-3"
              style={{ gap: '10px' }}
            >
              <h3 className="d-flex flex-row align-items-start m-0">
                <span
                  style={{
                    fontSize: 'clamp(0px,4.3vw,15px)',
                    whiteSpace: 'nowrap',
                  }}
                >
                  <MdOutlineCurrencyRupee className="" />
                </span>{' '}
                <span
                  style={{
                    fontSize: 'clamp(0px,7vw,25px)',
                    whiteSpace: 'nowrap',
                  }}
                >
                  {' '}
                  {price?.[1]?.price}
                </span>
              </h3>
              <span
                style={{
                  fontSize: 'clamp(0px,3.3vw,12px)',
                  whiteSpace: 'nowrap',
                }}
              >
                <MdOutlineCurrencyRupee className="mb-1" />
                <span style={{ textDecoration: 'line-through' }}>
                  {price?.[1]?.display_price}
                </span>
              </span>
            </div>
          </div>

          <div
            className="w-100 d-flex flex-row justify-content-between align-items-center px-3 pb-3 position-relative"
            style={{
              border: 'solid 1px #9D9D9D ',
              borderRadius: '5px',
              paddingTop: 'clamp(0px,10vw,24px)',
            }}
            onClick={() => handlePackClick(2)}
          >
            <div
              className="px-1 position-absolute"
              style={{
                background:
                  'linear-gradient(90deg, #CC151E -18.35%, #873662 108.23%)',
                color: 'white',
                fontSize: 'clamp(0px,2.9vw,13px)',
                fontWeight: 'bold',
                top: 0,
                right: 0,
                paddingTop: '2px',
                paddingBottom: '2px',
                borderRadius: '0px 4px 0px 0px',
              }}
            >
              {(
                (price?.[2]?.price - price?.[2]?.display_price) /
                price?.[2]?.display_price
              ).toFixed(2) * 100}
              %
            </div>
            <div
              className="px-1 position-absolute"
              style={{
                background:
                  'linear-gradient(90deg, #FEDA23 -18.35%, #FEA902 108.23%)',
                borderRadius: '4px',
                color: 'white',
                fontSize: 'clamp(0px,2.9vw,14px)',
                fontWeight: 'bold',
                top: 0,
                left: 0,
                paddingTop: '2px',
                paddingBottom: '2px',
              }}
            >
              Popular
            </div>
            <div className="col-8 ">
              <div
                className="d-flex flex-row align-items-center"
                style={{ gap: '10px' }}
              >
                <div
                  className=""
                  style={{
                    borderRadius: '50%',
                    border:
                      pack === 3 ? 'solid 1px #BF1A2A' : 'solid 1px #9D9D9D ',
                    height: 'fit-content',
                    padding: '3px',
                  }}
                >
                  <div
                    className=""
                    style={{
                      borderRadius: '50%',
                      border: 'none',
                      height: 'fit-content',
                      padding: '6px',
                      backgroundColor: pack === 3 ? '#BF1A2A' : '#FFF',
                    }}
                  ></div>
                </div>
                <img
                  src="/images/20coins.png"
                  style={{ width: 'clamp(0px,9vw,35px)', aspectRatio: '1/1' }}
                />
                <div className="text-start">
                  <h5
                    className="m-0"
                    style={{
                      fontSize: 'clamp(0px,4vw,16px)',
                      whiteSpace: 'nowrap',
                    }}
                  >
                    {price?.[2].coins} Coins
                  </h5>
                  <span
                    style={{
                      color: '#9D9D9D',
                      fontSize: 'clamp(0px,3.3vw,13px)',
                      whiteSpace: 'nowrap',
                    }}
                  >
                    ( Upto {price[2].songs}{' '}
                    {price[2].songs === 1 ? 'Request' : 'Requests'} )
                  </span>
                </div>
              </div>
            </div>

            <div
              className="d-flex flex-column justify-content-between col-3"
              style={{ gap: '10px' }}
            >
              <h3 className="d-flex flex-row align-items-start m-0">
                <span
                  style={{
                    fontSize: 'clamp(0px,4.3vw,15px)',
                    whiteSpace: 'nowrap',
                  }}
                >
                  <MdOutlineCurrencyRupee className="" />
                </span>{' '}
                <span
                  style={{
                    fontSize: 'clamp(0px,7vw,25px)',
                    whiteSpace: 'nowrap',
                  }}
                >
                  {' '}
                  {price?.[2]?.price}
                </span>
              </h3>
              <span
                style={{
                  fontSize: 'clamp(0px,3.3vw,12px)',
                  whiteSpace: 'nowrap',
                }}
              >
                <MdOutlineCurrencyRupee className="mb-1" />
                <span style={{ textDecoration: 'line-through' }}>
                  {price?.[2]?.display_price}
                </span>
              </span>
            </div>
          </div>
        </div>
      )}

      <button
        style={{
          width: '100%',
          padding: '8px 16px',
          marginTop: '1px',
          fontSize: 'clamp(0px,5vw,22px)',
          borderRadius: '10px',
          background:
            'linear-gradient(90deg, #CC151E -18.35%, #873662 108.23%)',
          color: 'white',
          border: 'none',
          maxWidth: '400px',
          position: 'relative',
        }}
        onClick={() => makeOrder(selectedPriceId)}
        disabled={loading || !selectedPriceId}
      >
        Continue
      </button>
    </div>
  );
};

export default BuyCoins;
